import { type ParameterID } from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Check if item is insurable
 *
 * @endpoint GET /api/ai/item/classify_insurable?title={item_title}&category_id={category_id}
 * @scope shared
 * @see https://flecto.dev/doc-822216
 */

export async function getClassifyInsurable(
  itemName: string,
  categoryId?: ParameterID
): Promise<{ insured: boolean }> {
  const params = new URLSearchParams()
  params.append('title', encodeURIComponent(itemName))
  if (categoryId) params.append('category_id', categoryId.toString())

  const { data } = await api.get(`/api/ai/item/classify_insurable?${params}`)
  return data
}
